import { envConfig } from "@env/env-config";

/**
 * @description 产品数据 Rest配置
 * @deprecated
 */
export const PartnerCartRestServiceConfig = {
    // 获取购物车数据
    getCart: {
        service: "partnerCartRestService",
        funcName: "getCart",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "api/partner/shoppingCart"
        }
    },
    // 批量删除
    multiDelete: {
        service: "partnerCartRestService",
        funcName: "multiDelete",
        config: {
            method: "delete",
            appPath: envConfig.apps.base,
            path: "api/partner/shoppingCart/items",
            paramDefaults: { itemIds: "@itemIds" }
        }
    },
    // 获取购物车项列表
    getItemList: {
        service: "partnerCartRestService",
        funcName: "getItemList",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "api/partner/shoppingCart/items"
        }
    },
    // 添加购物车项
    addToCart: {
        service: "partnerCartRestService",
        funcName: "addToCart",
        config: {
            method: "post",
            appPath: envConfig.apps.base,
            path: "api/partner/shoppingCart/items"
        }
    },
    // 计算勾选项的结算价格
    totalPrice: {
        service: "partnerCartRestService",
        funcName: "totalPrice",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "api/partner/shoppingCart/items/totalPrice",
            paramDefaults: { itemIds: "@itemIds" }
        }
    },
    // 获取购物车项数量
    totalQty: {
        service: "partnerCartRestService",
        funcName: "totalQty",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "api/partner/shoppingCart/items/totalQty"
        }
    },
    // 移除购物车项
    deleteCartItem: {
        service: "partnerCartRestService",
        funcName: "deleteCartItem",
        config: {
            method: "delete",
            appPath: envConfig.apps.base,
            path: "api/partner/shoppingCart/items/:shoppingCartItemId",
            paramDefaults: { shoppingCartItemId: "@shoppingCartItemId" }
        }
    },
    // 根据id获取指定购物车项
    getItem: {
        service: "partnerCartRestService",
        funcName: "getItem",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "api/partner/shoppingCart/items/:shoppingCartItemId",
            paramDefaults: { shoppingCartItemId: "@shoppingCartItemId" }
        }
    },
    // 更新购物车项
    updateItem: {
        service: "partnerCartRestService",
        funcName: "updateItem",
        config: {
            method: "put",
            appPath: envConfig.apps.base,
            path: "api/partner/shoppingCart/items/:shoppingCartItemId",
            paramDefaults: {
                shoppingCartItemId: "@shoppingCartItemId"
            }
        }
    },
    // 合并购物车
    mergeCart: {
        service: "partnerCartRestService",
        funcName: "mergeCart",
        config: {
            method: "post",
            appPath: envConfig.apps.base,
            path: "api/partner/shoppingCart/merger",
            paramDefaults: { anonymousUserId: "@anonymousUserId" }
        }
    },
    getMultiItems: {
        service: "partnerCartRestService",
        funcName: "getMultiItems",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "api/user/shoppingCart/items",
            paramDefaults: { itemIds: "@itemIds" }
        }
    },

    /**
     * @description: 生成预拼单项
     */
    cartPreBulkOrder: {
        service: "partnerCartRestService",
        funcName: "cartPreBulkOrder",
        config: {
            method: "post",
            appPath: envConfig.apps.base,
            path: "api/partner/shoppingCart/preBulkOrderItems",
        }
    }
}